// extracted by mini-css-extract-plugin
module.exports = {"root":"AnswerScale_root__yGRV5","options":"AnswerScale_options__2I5Ad","selected":"AnswerScale_selected__2g0lD"};